import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerLocale } from 'react-datepicker';
import { faIR } from "date-fns-jalali/locale";
import 'react-datepicker/dist/react-datepicker.css';

// ثبت locale فارسی
registerLocale('fa', faIR);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);